
const ctx = require.context("@/utils/", false, /globalvar\.js$/);

let list = ctx("./globalvar.js").default

function findData(field, value, findkey = "value", returnkey = "label") {
    let arr = null;
    if (typeof field == "string") {
        arr = list[field];
    } else {
        arr = field
    }
    let obj = arr.find(item => {
        if (item[findkey] instanceof Array) {
            return item[findkey].includes(value)
        } else {
            return item[findkey] == value
        }
    });
    if (obj) {
        return returnkey ? obj[returnkey] : obj
    } else {
        return ""
    }
}


export { findData }



// WEBPACK FOOTER //
// ./src/utils/globalvarFind.js